<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      v-if="nEstPasLeClient"
      :list="sas.identificationsClients"
      add-new-text="Ajouter une identification client"
      :live="{ endpoint: 'sas-identification-client', sasId: sas.id }"
      :icon="$getIcon('services')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.prenom }} {{ item.nom }}</h3>
      </template>

      <template v-slot:edit-mode="{ item }">
        <opq-text-field
          code="enquete_nomclient"
          v-model="item.nom"
          :ref="'nom-' + item.id"
          :live="liveSasIdentificationClient(23403, item)"
        ></opq-text-field>

        <opq-text-field
          code="enquete_prenomclient"
          v-model="item.prenom"
          :ref="'prenom-' + item.id"
          :live="liveSasIdentificationClient(23402, item)"
        ></opq-text-field>

        <opq-catalogue
          code="enquete_lienrequerant"
          v-model="item.lienAvecLeRequerant"
          :live="liveSasIdentificationClient(23404, item)"
          order-by="text"
          optional
        ></opq-catalogue>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasDemandeEnquete() {
      return this.sas.sasDemandeEnquete
    },

    nEstPasLeClient() {
      return this.estNon(this.sasDemandeEnquete.etesVousLeClient)
    }
  },

  methods: {
    liveSasIdentificationClient(cle, item) {
      return { endpoint: "/sas-identification-client/", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>